@import '../../../../globals/main.scss';
$userChatMessageBackgroundColor: $blue50;
$userChatMessageTextColor: $gray900;
$privateChatMessageLinkColor: $blue25;
$businessChatMessageLinkColor: $coral50;

$message-padding: 1rem 1.6rem;

pn-chat-message {
  display: flex;
  text-align: left;

  &.user,
  &.buttonresponse {
    justify-content: flex-end;
  }

  &.system-message {
    text-align: center;
    justify-content: center;
  }

  .message-container {
    border-radius: 0.8rem;
    display: flex;
    gap: 1rem;
    max-width: 85%;
    overflow-x: hidden;

    .category {
      width: 2.6rem;
    }

    &.user {
      max-width: 75%;
    }

    &.bot,
    &.agent,
    &.link {
      .message {
        background-color: $gray50;
      }

      .category {
        align-self: flex-end;
      }
    }
    
    &.link {
      .category {
        align-self: center;
      }

      flex-basis: 100%;
      .content {
        line-height: 1.5;
      }

      .message {
        padding: 0;

        a {
          color: $blue700;
          font-weight: 500;
          display: flex;
          justify-content: space-between;
          padding: $message-padding;
          text-decoration: underline;
        }
      }
    }

    &.link .business.message {
      background-color: $businessChatMessageLinkColor;
    }

    &.button {
      flex-basis: 100%;
      text-align: center;
      max-width: unset;

      .message {
        padding: 0;
      }

      .pn-button {
        min-width: 18rem;

        &:disabled {
          color: $gray400;
          
          .pn-button-bg {
            border-color: $gray50;
            background-color: $gray50;
          }
        }
      }
    }

    &.card {
      border: solid 1px $gray200;
      border-radius: 1.6rem;
      flex-basis: 100%;
      max-width: 100%;

      .message {
        display: flex;
        flex-direction: column;
        gap: 0.8rem;
        padding: 1.6rem;
      }

      .card-heading {
        font-size: 1.6rem;
        line-height: 2.4rem;
        font-weight: 700;
      }

      .cta {
        display: flex;
        flex-direction: row;
        gap: 0.5rem;
      }

      .read-more {
        align-self: flex-start;
        margin-top: auto;
      }
    }

    &.user,
    &.buttonresponse {
      .message {
        background-color: $userChatMessageBackgroundColor;
        color: $userChatMessageTextColor;
        border-radius: 0.8rem 0.8rem 0 0.8rem;
      }
    }

    .message {
      border-radius: 0 0.8rem 0.8rem 0.8rem;
      display: inline-block;
      flex: 1 1 auto;
      font-size: 1.4rem;
      line-height: 2rem;
      padding: $message-padding;
      word-wrap: break-word;
      overflow-wrap: break-word;
      white-space: normal;
      word-break: break-word;

      @media (max-width: 767px) {
        font-size: 1.6rem;
      }
    }

    &.agent {
      .category .pn-icon {
        background-color: $blue400;
        color: $white;
        text-align: center;
        border-radius: 50%;
        display: inline-block;
        width: 2.5rem;
        height: 2.5rem;
        font-weight: 500;
        font-size: 1.2rem;
        line-height: 2.6rem;
      }
    }
  }

  &[data-card] {
    height: 100%;
  }
}